module.exports = __webpack_public_path__ + "static/media/correct-green.7e382d04.svg";